import { AutocompleteOption } from '@types'

import { FIELD_BIND_TYPE_ENUM } from './tables'

export enum MAP_STATION_CODE {
  DME = 'dme',
  VKO = 'vko',
  TBS = 'tbs',
  SVO = 'svo',
}

export enum MAP_POINT_GROUP_LABEL_BIND_TYPE {
  JS = 'JS',
}

export enum MAP_POINT_GROUP_LABEL_POSITION {
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TOP = 'top',
}

export enum MAP_POINT_GROUP_LABEL_ALIGNMENT {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

/**
 * Enum для провайдеров карт
 */
export enum MapProviderType {
  MAP_2GIS = '2GIS',
  YANDEX = 'YANDEX',
  MAPLIBRE = 'MAPLIBRE',
}

export enum MAP_TABS {
  GENERAL,
  MAP_SETTINGS,
  POINT_GROUPS,
}

export const LABEL_POSITIONS: AutocompleteOption<MAP_POINT_GROUP_LABEL_POSITION>[] = [
  { id: MAP_POINT_GROUP_LABEL_POSITION.TOP, label: 'Top' },
  { id: MAP_POINT_GROUP_LABEL_POSITION.BOTTOM, label: 'Bottom' },
  { id: MAP_POINT_GROUP_LABEL_POSITION.LEFT, label: 'Left' },
  { id: MAP_POINT_GROUP_LABEL_POSITION.RIGHT, label: 'Right' },
]

export const LABEL_ALIGNMENTS: AutocompleteOption<MAP_POINT_GROUP_LABEL_ALIGNMENT>[] = [
  { id: MAP_POINT_GROUP_LABEL_ALIGNMENT.CENTER, label: 'Center' },
  { id: MAP_POINT_GROUP_LABEL_ALIGNMENT.LEFT, label: 'Left' },
  { id: MAP_POINT_GROUP_LABEL_ALIGNMENT.RIGHT, label: 'Right' },
]

export const LABEL_BIND_TYPES: AutocompleteOption<FIELD_BIND_TYPE_ENUM>[] = [
  { id: FIELD_BIND_TYPE_ENUM.JS, label: FIELD_BIND_TYPE_ENUM.JS },
]

export const POINT_COLOR_BIND_TYPES: AutocompleteOption<FIELD_BIND_TYPE_ENUM>[] = [
  { id: FIELD_BIND_TYPE_ENUM.STATIC, label: FIELD_BIND_TYPE_ENUM.STATIC },
  { id: FIELD_BIND_TYPE_ENUM.JS, label: FIELD_BIND_TYPE_ENUM.JS },
]

export const MAP_DEFAULT_ZOOM = 10

export const MAP_DEFAULT_CENTER_LATITUDE = 55.6027
export const MAP_DEFAULT_CENTER_LONGITUDE = 37.2822

export const MAP_DEFAULT_MAX_BOUNDS_SW_LATITUDE = 55.5798
export const MAP_DEFAULT_MAX_BOUNDS_SW_LONGITUDE = 37.2115
export const MAP_DEFAULT_MAX_BOUNDS_NE_LATITUDE = 55.6281
export const MAP_DEFAULT_MAX_BOUNDS_NE_LONGITUDE = 37.35

export type MapStationDefaults = {
  zoom: number
  centerLatitude: number
  centerLongitude: number
  swLatitude: number
  swLongitude: number
  neLatitude: number
  neLongitude: number
}

export const MAP_STATION_DEFAULTS: Record<MAP_STATION_CODE, MapStationDefaults> = {
  [MAP_STATION_CODE.VKO]: {
    zoom: MAP_DEFAULT_ZOOM,
    centerLatitude: MAP_DEFAULT_CENTER_LATITUDE,
    centerLongitude: MAP_DEFAULT_CENTER_LONGITUDE,
    swLatitude: MAP_DEFAULT_MAX_BOUNDS_SW_LATITUDE,
    swLongitude: MAP_DEFAULT_MAX_BOUNDS_SW_LONGITUDE,
    neLatitude: MAP_DEFAULT_MAX_BOUNDS_NE_LATITUDE,
    neLongitude: MAP_DEFAULT_MAX_BOUNDS_NE_LONGITUDE,
  },
  [MAP_STATION_CODE.DME]: {
    zoom: MAP_DEFAULT_ZOOM,
    centerLatitude: 55.41,
    centerLongitude: 37.9,
    swLatitude: 55.3473,
    swLongitude: 37.74,
    neLatitude: 55.4689,
    neLongitude: 38.0827,
  },
  [MAP_STATION_CODE.SVO]: {
    zoom: MAP_DEFAULT_ZOOM,
    centerLatitude: 55.9768,
    centerLongitude: 37.4115,
    swLatitude: 55.9392,
    swLongitude: 37.3304,
    neLatitude: 55.9969,
    neLongitude: 37.5018,
  },
  [MAP_STATION_CODE.TBS]: {
    zoom: MAP_DEFAULT_ZOOM,
    centerLatitude: 41.67,
    centerLongitude: 44.961,
    swLatitude: 41.6521,
    swLongitude: 44.9141,
    neLatitude: 41.6907,
    neLongitude: 44.9997,
  },
}

export const MAP_DEFAULT_PROVIDER = MapProviderType.MAPLIBRE

export const MAP_DEFAULT_POINT_COLOR = '#919c9c'

/**
 * Провайдеры растрового imagery-слоя
 * (спутниковая/аэросъёмка и другие подложки)
 */
export enum ImageryProviders {
  ESRI_WORLD_IMAGERY = 'esri-world-imagery',
}

export const MAP_DEFAULT_SETTINGS_PROPERTIES = {
  // Демонстрационный COG-источник (локальный/удалённый COG).
  // Используем публичный файл из примера MapLibre:
  //   https://maplibre.org/maplibre-gl-js/docs/assets/cog.tif
  cogSource: {
    id: 'cog-source-demo',
    layerId: 'cog-layer-demo',
    fileName: 'cog-demo-remote.tif',
    url: 'https://maplibre.org/maplibre-gl-js/docs/assets/cog.tif',
    tileSize: 256,
    opacity: 0.7,
    enabledByDefault: false,
  },
  // Демонстрационный imagery-слой Esri World Imagery.
  imageryLayer: {
    provider: ImageryProviders.ESRI_WORLD_IMAGERY,
    sourceId: 'esri-world-imagery-source',
    layerId: 'esri-world-imagery-layer',
    opacity: 0.7,
    enabledByDefault: false,
  },
}
